import styled from 'styled-components';
import { Image } from 'antd';

export const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const HeaderTitle = styled.h1`
	font-weight: 400;
	font-size: 18px;
	line-height: 24px;
	letter-spacing: -0.5%;
	margin: 0 0 0 2rem;
`;

export const HeaderSubTitle = styled.h2`
	font-weight: 600;
	font-size: 25px;
	line-height: 32px;
	letter-spacing: -0.5%;
	margin: 0 0 0 2rem;
`;

export const ImageStyled = styled(Image)`
	max-height: 170px;
	width: 90%;
`;
